import GetTextContentByIdRequestModelBase from '../_generated/modelBases/get-text-content-by-id-request-model-base';

export default class GetTextContentByIdRequestModel extends GetTextContentByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
